var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{attrs:{"loading":_setup.isLoading,"empty":_setup.isEmpty}},[_c(_setup.BreifCard,{attrs:{"listData":_setup.currentData,"styleConfig":_vm.styleConfig},on:{"goToDetail":_setup.goDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }